import { VisionApplication } from '../../application';
import { VisionMap } from '../../map/map';
import { VisionPlowingTab } from './plowing';

export class PlowingMap {
    map!: VisionMap;
    parent: VisionPlowingTab;

    heatmapLayer!: google.maps.visualization.HeatmapLayer;

    constructor(tab: VisionPlowingTab) {
        this.parent = tab;
        tab.tabbar.cells('map').attachHTMLString('<div id="plowing_map_id" style="width:100%;height:100%"></div>');

        this.map = new VisionMap('plowing_map_id');
        this.map.init('plowing_map', this.parent.app.organizationService.dto?.latitude, this.parent.app.organizationService.dto?.longitude).then(() => {
            this.heatmapLayer = new google.maps.visualization.HeatmapLayer({});
            const map = this.map.map;
            this.heatmapLayer.setMap(map);
            VisionApplication.getInstance().setMapWorkspace(this.map.map);
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public setData(heatData: any) {
        this.heatmapLayer.setData(heatData);
        const gradient = [
            'rgba(0, 255, 255, 0)',
            'rgba(0, 255, 255, 1)',
            'rgba(0, 191, 255, 1)',
            'rgba(0, 127, 255, 1)',
            'rgba(0, 63, 255, 1)',
            'rgba(0, 0, 255, 1)',
            'rgba(0, 0, 223, 1)',
            'rgba(0, 0, 191, 1)',
            'rgba(0, 0, 159, 1)',
            'rgba(0, 0, 127, 1)',
            'rgba(63, 0, 91, 1)',
            'rgba(127, 0, 63, 1)',
            'rgba(191, 0, 31, 1)',
            'rgba(255, 0, 0, 1)',
        ];

        this.heatmapLayer.set('gradient', this.heatmapLayer.get('gradient') ? null : gradient);
        this.heatmapLayer.set('opacity', 1.0);
    }
}
